import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import React, { useContext, useEffect, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';

import senslaLogo from 'assets/images/sensla-short-greyscale.png';
import slackLogo from 'assets/images/slack.svg';
import addToMs from 'assets/images/msAdd.png';
import msLogo from 'assets/images/microsoft-teams.svg';
// import Processing from '../animations/Processing';

import useInterval from 'hooks/useInterval';
import { ctx, IStore } from '../../store';

import { useStyles } from './styles';

interface IProps {
  data?: any;
  user: any;
}

const SLACK_CLIENT_ID = process.env.REACT_APP_SLACK_CLIENT_ID;
const SLACK_ADD_REDIRECT_URI = process.env.REACT_APP_SLACK_ADD_REDIRECT_URI;
const MS_CLIENT_ID = process.env.REACT_APP_MS_CLIENT_ID;
const MS_ADD_REDIRECT_URI = process.env.REACT_APP_MS_ADD_REDIRECT_URI;

const TeamCard: React.FC<IProps> = ({ data, user }) => {
  const [intervalTime, setIntervalTime] = useState<any>(30000);
  const [isActive, setActive] = useState<boolean>(data.active);
  const actions = useContext(ctx.actions);
  const history = useHistory();
  const classes = useStyles();

  useEffect(() => {
    if (data.active) {
      setActive(true);
      setIntervalTime(null);
    } else {
      if (data.teamId) {
        setIntervalTime(10000);
      } else {
        setIntervalTime(30000);
      }
    }
  }, [data]);

  const navigateTo = async () => {
    const {
      teams: { currentTeam },
    } = await ((actions.teams.setCurrentTeam(data) as unknown) as Promise<IStore>);
    if (currentTeam.preset) {
      history.push('/dashboard');
    } else {
      history.push('/preset');
    }
  };

  useInterval(() => {
    const fetch = async () => {
      if (data.teamId) {
        await ((actions.teams.getTeams() as unknown) as Promise<IStore>);
      } else {
        await ((actions.tenants.getTenants() as unknown) as Promise<IStore>);
      }
    };

    if (!data.active) {
      fetch();
    }
  }, intervalTime);

  const insideSupervisors =
    !!data.supervisors && data.supervisors.map((item: any) => item.email).includes(user.email);

  function onClick() {
    if (!data.active || insideSupervisors) {
      navigateTo();
    }
  }

  return (
    <Card className={classes.card}>
      <Grid className={classes.cardArea} onClick={onClick}>
        <Grid className={classes.cardMedia}>
          <CardMedia
            className={classes.image}
            // style={{ opacity: data.avatar ? 1 : 1 }}
            image={data.avatar ? data.avatar : senslaLogo}
          />
          <img
            alt="platform logo"
            className={classes.platformLogo}
            src={data.teamId ? slackLogo : msLogo}
          />
        </Grid>
        <CardContent className={classes.cardContent}>
          <Typography variant="h4" className={classes.teamName}>
            {data.name}
          </Typography>
          {/* {!isActive && (
            <>
              {data.processing && <Processing />}
              <Typography variant="body2" color="textSecondary" component="p">
                {data.processing
                  ? 'We are preparing your dashboard. This could take a couple of minutes, please wait!'
                  : 'Sensla has not been activated in this Workspace. Please add it to continue!'}
              </Typography>
            </>
          )} */}
        </CardContent>
      </Grid>
      {!data.processing && (
        <CardActions className={classes.cardActions}>
          {isActive ? (
            <Button
              className={classes.button}
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              onClick={onClick}
              disabled={!insideSupervisors}
            >
              <Typography className={classes.buttonText}>
                {insideSupervisors ? 'Go To Dashboard' : 'Request Access to an Admin'}
              </Typography>
            </Button>
          ) : data.teamId ? (
            <a
              href={`https://slack.com/oauth/v2/authorize?redirect_uri=${SLACK_ADD_REDIRECT_URI}&team=${data.teamId}&client_id=${SLACK_CLIENT_ID}&state=${user.email}&scope=app_mentions:read,channels:history,channels:join,channels:manage,channels:read,chat:write,groups:history,groups:read,groups:write,im:write,team:read,users.profile:read,users:read,users:read.email&user_scope=channels:read,groups:read,team:read,users:read`}
              className={classes.linkSocial}
            >
              <img
                className={classes.buttonSocialSlack}
                alt="Add to Slack"
                src="https://platform.slack-edge.com/img/add_to_slack.png"
                srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
              />
            </a>
          ) : (
            <a
              className={classes.linkSocial}
              href={`https://login.microsoftonline.com/${data.tenantId}/adminconsent?client_id=${MS_CLIENT_ID}&state=${user.email}&redirect_uri=${MS_ADD_REDIRECT_URI}`}
            >
              <img alt="Sign in with Microsoft" className={classes.buttonSocialMs} src={addToMs} />
            </a>
          )}
        </CardActions>
      )}
    </Card>
  );
};

export { TeamCard };
